import { hasYesOrNo } from 'models/validate';
import psychologicalHospitalizationItemValidator from 'forms/sections/psychological/hospitalizations/validators/item';
import { ValidateJSModel } from 'forms/shared/types';
import { PsychologicalHospitalizationsModel } from './types';

const psychologicalHospitalizationsValidator: ValidateJSModel<PsychologicalHospitalizationsModel> = {
  Hospitalized: { presence: true, hasValue: { validator: hasYesOrNo } },

  List: (value, attributes) => {
    if (attributes?.Hospitalized && attributes?.Hospitalized.value === 'Yes') {
      return {
        presence: true,
        accordion: { validator: psychologicalHospitalizationItemValidator },
      };
    }
    return {};
  },

  Comments: {},

  SummaryComments: {},
};

export default psychologicalHospitalizationsValidator;
